module.exports = __webpack_public_path__ + "media/stylesheets/images/kurashino_media-907d5f7e91c4dee7eed0815248f84264.png";